import axios, { InternalAxiosRequestConfig } from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL })
// const API = axios.create({ baseURL: 'https://sanme-portfolio-c47c6ed45f5f.herokuapp.com' })

//This is going to be a function that's going to happen on each one of our request
API.interceptors.request.use(
  (req) => {
    const authData = localStorage.getItem('authData');

    if (authData && req.headers) {
      const token = JSON.parse(authData).token;
      req.headers.Authorization = `Bearer ${token}`;
    }

    return req;
  },
  (error) => Promise.reject(error)
);

export interface PostDataParams{
    username?: string;
    password?: string;
}

export interface ApiParams {
    currentPage?: number;
    page?: any;
    id?: any;
    user?: any;
    otp?: any;
    postType?: any;
    category?: any;
    ref?: any;
    location?: any;
    detailId?: any;
    value?: any;
    tag?: any;
    storeId?: any;
    sort?: any;
    updatedData?: any;
    updatedResult?: any;
    updatedAdmin?: any;
    updatedProfile?: any;
    updatedPayment?: any;
    updatedPostLike?: any;
    updatedPostRating?: any;
    updatedPostReview?: any;
    searchQuery?: any;
    emailToken?: any;
    emailAddress?: any;
    updatedPassword?: any;
    updatedOrder?: any;
    updatedUser?: any;
    formData?: PostDataParams;
    postData?: any;
    userId?: any;
    postId?: any;
    fromUserId?: any;
    type?: any;
    newPost?: any;
    updatedPost?: any;
}

const admins           = '/admins'
const profiles         = '/profiles'
const users            = '/users'
const enrollment       = '/enrollment'
const notifications    = '/notifications'
const contactUs        = '/contact-us'
const newsLetter       = "/news-letter"

//admins
export const fetchAdmins               = ({page}: ApiParams) => API.get(`${admins}?page=${page}`)
export const fetchAdmin                = ({id}: ApiParams) => API.get(`${admins}/admin/${id}`)
export const createAdmin               = ({postData}: ApiParams) => API.post(`${admins}/signup`, postData)
export const updateAdmin               = ({id, postData}: ApiParams) => API.patch(`${admins}/update/${id}`, postData)
export const fetchAdminsBySearch       = ({searchQuery, page}: ApiParams) => API.get(`${admins}/search?searchQuery=${searchQuery.search || 'none'}&page=${page}`)
export const deleteAdmin               = ({id}: ApiParams) => API.delete(`${admins}/delete/${id}`)
export const verifyAdminRegEmail       = ({id, emailAddress, otp}: ApiParams) => API.get(`${admins}/admin/${id}/verify/${emailAddress}/otp/${otp}`)
export const resendAdminVerification   = ({emailAddress}: ApiParams) => API.post(`${admins}/resend-verification/${emailAddress}`)
export const verifyAdminEmailPassword  = ({emailAddress}: ApiParams) => API.post(`${admins}/verify-email-password/${emailAddress}`)
export const passwordResetAdmin        = ({id, updatedPassword}: ApiParams) => API.put(`${admins}/reset/${id}`, updatedPassword)
export const signInAdmin               = (postData: PostDataParams ) => API.post(`${admins}/signin`, postData)
//-------------------------------------------------------------------------------------------------------------------------------

//enrollment
export const fetchEnrollmentUsers      = ({page}: ApiParams) => API.get(`${enrollment}?page=${page}`)
export const fetchEnrollmentUser       = ({id}: ApiParams) => API.get(`${enrollment}/${id}`);
export const createEnrollment          = ({postData}: ApiParams) => API.post(`${enrollment}/create`, postData)
export const fetchEnrollmentsBySearch  = ({searchQuery, page}: ApiParams) => API.get(`${enrollment}/search?searchQuery=${searchQuery.search || 'none'}&page=${page}`)
export const updateEnrollment          = ({id, postData}: ApiParams) => API.patch(`${enrollment}/update/${id}`, postData)
export const deleteEnrollment          = ({id}: ApiParams) => API.delete(`${enrollment}/delete/${id}`)
//-------------------------------------------------------------------------------------------------------------------------

//profiles
export const fetchProfiles            = ({page}: ApiParams) => API.get(`${profiles}?page=${page}`)
export const fetchProfile             = ({id}: ApiParams) => API.get(`${profiles}/${id}`)
export const createProfile            = ({postData}: ApiParams) => API.post(`${profiles}/create`, postData)
export const updateProfile            = ({id, postData}: ApiParams) => API.patch(`${profiles}/update/${id}`, postData)
export const fetchProfilesBySearch    = ({searchQuery, page}: ApiParams) => API.get(`${profiles}/search?searchQuery=${searchQuery.search || 'none'}&page=${page}`)
export const deleteProfile            = ({id}: ApiParams) => API.delete(`${profiles}/delete/${id}`)
//-------------------------------------------------------------------------------------------------------------------------------
// users
export const fetchUsers            = ({page}: ApiParams) => API.get(`${users}?page=${page}`)
export const fetchUser             = ({id}: ApiParams) => API.get(`${users}/${id}`)
export const fetchUserProfile      = ({userId}: ApiParams) => API.get(`${profiles}/user/${userId}`)
export const createUser            = ({postData}: ApiParams) => API.post(`${users}/signup`, postData)
export const updateUser            = ({id, postData}: ApiParams) => API.patch(`${users}/${id}`, postData)
export const fetchUsersBySearch    = ({searchQuery, page}: ApiParams) => API.get(`${users}/search?searchQuery=${searchQuery.search || 'none'}&page=${page}`)
export const deleteUser            = ({id}: ApiParams) => API.delete(`${users}/${id}`)
export const verifyUserRegEmail    = ({id, emailToken}: ApiParams) => API.get(`${users}/user/${id}/verify/${emailToken}`)
export const resendVerification    = ({emailAddress}: ApiParams) => API.post(`${users}/resend-verification/${emailAddress}`)
export const verifyEmailPassword   = ({emailAddress}: ApiParams) => API.post(`${users}/verify-email-password/${emailAddress}`)
export const passwordReset         = ({id, updatedPassword}: ApiParams) => API.put(`${users}/reset/${id}`, updatedPassword)
// export const signInUser            = (formData) => API.post(`${users}/signin`, formData)
//-------------------------------------------------------------------------------------------------------------------------------

//notifications
export const fetchNotifications       = ({page}: ApiParams) => API.get(`${notifications}?page=${page}`)
export const fetchNotification        = ({id}: ApiParams) => API.get(`${notifications}/notification/${id}`)
export const fetchMarkSingleAsReadNotificationsByUser = ({id, userId}: ApiParams) => API.patch(`${notifications}/${id}/markSingleRead/${userId}`)
export const createNotification       = ({userId, postId, fromUserId, type}: ApiParams) => API.post(`${notifications}/create`, {userId, postId, fromUserId, type})
//-------------------------------------------------------------------------------------------------------------------------------

//contact us
export const createContactUsMessage = ({formData}: ApiParams) => API.post(`${contactUs}/create`, formData)
export const fetchContactMessage    = ({id}: ApiParams) => API.get(`${contactUs}/message/${id}`)
export const fetchContactMessages   = ({page}: ApiParams) => API.get(`${contactUs}?page=${page}`)
export const deleteContactUsMessage = ({id}: ApiParams) => API.delete(`${contactUs}/delete/${id}`)
//-------------------------------------------------------------------------------------------------------------------------------

//newsletter
export const createNewsLetter      = ({postData}: ApiParams) => API.post(`${newsLetter}/create`, postData)
export const fetchNewsLetter       = ({page}: ApiParams) => API.get(`${newsLetter}?page=${page}`)